import {
	isNullOrUndefined, 
} from './typeChecks';


/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 * 
 * @param {Object} object
 * @param {string[] | string} path
 * @param {*} defaultValue
 * @returns {*}
 */
export function get(object: Object, path: string[] | string, defaultValue?: any):any {
	if (path === undefined) {
		return defaultValue;
	}
	path = Array.isArray(path) ? path : path.split('.');
	let result = object;

	if (!isNullOrUndefined(result)) {
		for (const pathValue of path) {
			const parts = pathValue.split('[');
			for (const part of parts) {
				if (isNullOrUndefined(result)) {
					break;
				}
				const workingPart = part.replace(']', '');
				result = result[workingPart];
			}
			if (isNullOrUndefined(result)) {
				break;
			}
		}
	}
	return result !== undefined ? result : defaultValue;
}